import { render, staticRenderFns } from "./applicants-section.vue?vue&type=template&id=0fc6e4cc&scoped=true"
import script from "./applicants-section.vue?vue&type=script&lang=ts"
export * from "./applicants-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6e4cc",
  null
  
)

export default component.exports